import { Children, cloneElement } from 'react';

import { useTasksGetQuery } from '../../Common/Queries/tasksQueries';

export function GetNotificationsContainer({ children }) {
  const notifications = useTasksGetQuery();

  return Children.only(cloneElement(children, { notifications }));
}
